// Parallax depth model for the pull-to-refresh scenes.
//
// The 800x150 scene composition is bottom-anchored to the content-sheet edge,
// so with no offset every layer would ride along with the content. Each layer
// counter-translates by -(pullOffset) * (1 - depth), which makes it move at
// `depth` x the speed of the content edge in the viewport: depth 0 = pinned
// to the viewport (static backdrop), depth 1 = rides the sheet edge.
// pullOffset = bandHeight - 150: negative while pulling, 0 at the settled
// refresh height, positive during overshoot.

export const DEPTH_SKY = 0.1;
export const DEPTH_FAR = 0.3;
export const DEPTH_MID = 0.6;
export const DEPTH_GROUND = 1.0;
export const DEPTH_HERO = 0.85;

// Must match the band height transition in components/refresh/index.js so
// the layers and the band edge move in sync during the smoothed drag.
export const LAYER_EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';

export function layerOffsetPx(pullOffset, depth) {
    return -pullOffset * (1 - depth);
}

export function layerTransform(pullOffset, depth) {
    // `|| 0` normalizes -0 (depth 1.0 with positive pullOffset) so the CSS
    // never reads translateY(-0.0px).
    const value = layerOffsetPx(pullOffset, depth) || 0;
    return `transform: translateY(${value.toFixed(1)}px); transition: transform 0.3s ${LAYER_EASING}; will-change: transform;`;
}
